import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationComponent } from './notification/notification.component';
import { NotificationService } from './notification/notification.service';

@NgModule({
  declarations: [NotificationComponent],
  imports: [CommonModule],
  providers: [NotificationService],
  exports: [NotificationComponent]
})
export class NotificationModule {}
